<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- In subjective component props: -- selcrs- {{ sel_crs }} <br />
    chap-{{ chapter }} <br />
    typ- {{ quiztype }} <br /> -->
    <span class="slide">*NOTE:Question Image File size Should be less than {{ imagesize_new }} KB
      And It Should be in
      <span v-for="(img, index) in imagetype_new" :key="index">
        {{ img.imagetype }} </span>Format!!!</span>
    <v-row dense justify="center"><strong>Question No. {{ question_size }}</strong></v-row>
    <v-card class="box">
      <v-row justify="center">
        <span v-if="imageSizeFlag">
          <v-col cols="12" xs="12" sm="12">
            <p class="slide">
              Question File size should be less than {{ imagesize_new }}KB!
            </p>
          </v-col>
        </span>
        <span v-if="imageTypeFlag">
          <v-col cols="12" xs="12" sm="12">
            <p class="slide">
              Question File in
              <span v-for="(img, index) in imagetype_new" :key="index">
                {{ img.imagetype }}
              </span>
              Format!!!
            </p>
          </v-col>
        </span>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="12" sm="3" md="3">
          <v-text-field color="#0F2027" label="Marks" v-model.trim="weightage" type="number" required></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="12" sm="7" md="7">
          <ckeditor v-model="question" :config="editorConfig"></ckeditor>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-col cols="12" sm="10" md="10">
            <v-file-input v-model="qfile" id="file" accept="image/*" prepend-icon="mdi-attachment" label="Choose File"
              show-size name="doc" @change="validateFile()"></v-file-input>
          </v-col>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="button" @click="showStudents()">Select Students</v-btn>
      </v-row>
    </v-card>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please Wait
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-row justify="center">
      <v-dialog v-model="show_studnts" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar class="toolbar">
            <v-btn icon dark @click="show_studnts = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>All Students</v-toolbar-title>
            <v-toolbar-items>
              <v-btn dark text @click="show_studnts = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card class="box">
            <v-row class="sub-row" justify="center" dense>
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                <v-data-table :headers="headers_students" :items="learners" :search="search" class="elevation-1"
                  show-select v-model="selected" item-key="lid" :items-per-page="-1"></v-data-table>
              </v-col>
            </v-row>
          </v-card>
          <v-row justify="center">
            <v-btn class="button" @click="savesubjective()" :loading="loader">Save & Publish</v-btn>
          </v-row>
          <v-row justify="center" dense v-if="this.selected.length > 0">
            <strong>Total Selected - {{ selected.length }}</strong>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>


  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  props: {
    chapter: Number,
    sel_crs: Array,
    quiztype: String,
    Level: Number,
  },
  data() {
    return {
      overlay: false,
      loader: false,
      editorConfig: {
        height: "100px",
        extraPlugins: "mathjax",
        mathJaxLib:
          "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
      },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: null,
      overlay: false,
      crs_list: null,
      crs: null,
      chapter_list: null,
      chapter: null,
      qfile: null,
      isapprove: true,
      weightage: 1,
      question: null,
      question_size: null,
      imagesizeflaginputs: false,
      imagesizetypeinputs: false,
      imagesize: null,
      imageSizeFlag: false,
      imageTypeFlag: false,
      dialog_zooimg: false,
      dialog_save: false,
      dialog_save_option: false,
      dialog_upload: false,
      imagesize_new: null,
      imagetype_new: null,
      headers_students: [
        { text: "Sr. No.", value: "count", sortable: "true" },
        { text: "Student", value: "name" },
      ],
      learners: [], show_studnts: false, search: null, total_students: [], selected: [],
    };
  },
  methods: {
    showStudents() {
      if (this.qfile == null && this.question == "") {
        this.showSnackbar("#b71c1c", "Please Add The Question !!!"); // show snackbar
        return;
      }
      this.show_studnts = true
      this.markAllSelected();
    },
    markAllSelected() {
      this.selected = []
      for (let i = 0; i < this.learners.length; i++) {
        this.selected.push(this.learners[i]);
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    getQuestionBank() {
      console.log("getquestionbank12", this.sel_crs[0].coff_id);

      const data = {
        crs_id: this.sel_crs[0].coi_id,
        ch_id: this.chapter,
        type: this.quiztype,
        Level_id: this.Level,
      };
      axios
        .post("/QuizQuestionBank/getQuestionBank", data)
        .then((res) => {
          this.question_size = res.data.question_size;
          this.imagesize_new = res.data.imagesize / 1000;
          this.imagetype_new = res.data.imagetype;
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => { });
    },
    // reset call from  save funct
    reset() {
      (this.question = null), (this.qfile = null), (this.weightage = 1);
    },
    validateFile() {
      let file = this.qfile;
      let file_size = file.size;
      let file_name = this.qfile.name;
      let ext = file_name.split(".").pop();
      const data = {
        type: this.quiztype,
      };
      axios
        .post("/QuizQuestionBank/validatefile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.imagesize = res.data.imagesize;
            if (file_size > this.imagesize) {
              //200kb
              this.imageSizeFlag = true;
              this.qfile = null;
            } else {
              this.imageSizeFlag = false;
            }
            this.imagetype = res.data.imagetype;
            //console.log(this.imagetype)
            for (var i = 0; i < this.imagetype.length; i++) {
              //alert(i)
              //alert(this.imagetype[i].imagetype)
              if (ext == this.imagetype[i].imagetype) {
                // alert("in if")
                this.imageTypeFlag = false;
                return;
              }
            }
            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext != this.imagetype[i].imagetype) {
                // alert("in else new for")
                this.imageTypeFlag = true;
                this.qfile = null;
                return;
              }
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        });
    },
    savesubjective() {
      let formData = new FormData();
      if (this.imagesizeflaginputs) {
        this.showSnackbar("#b71c1c", "Please check file size!!!"); // show snackbar
        return false;
      }
      if (this.imagesizetypeinputs) {
        this.showSnackbar("#b71c1c", "Please check file extension!!!"); // show snackbar
        return false;
      }
      formData.append("qfile", this.qfile);
      formData.append("weightage", this.weightage);
      formData.append("question", this.question);
      formData.append("ch_id", this.chapter);
      formData.append("Level_id", this.Level);
      formData.append("crs_id", this.sel_crs[0].coff_id);
      formData.append("type", this.quiztype);
      for (let i = 0; i < this.sel_crs.length; i++) {
        formData.append("coi_id", this.sel_crs[i].coi_id);
      }
      if (this.qfile == null && this.question == "") {
        this.showSnackbar("#b71c1c", "Please Add The Question !!!"); // show snackbar
        return;
      }
      for (var i = 0; i < this.selected.length; i++) {
        this.total_students.push(this.selected[i].lid);
        formData.append("total_students", this.selected[i].lid);
      }
      if (this.total_students.length <= 0) {
        this.showSnackbar("#b71c1c", "Please select Students!"); // show snackbar
      }
      this.dialog_upload = true;
      this.overlay = true;
      this.loader = true;
      axios
        .post("/LiveClass/saveQuestionInBank", formData, {})
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully...");
            this.dialog_upload = false;
            this.reset();
            this.getQuestionBank()
            this.total_students = [],
              this.show_studnts = false
            this.overlay = false
            this.loader = false
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
          this.dialog_upload = false;
          this.overlay = false
          this.loader = false
        })
        .finally(() => {
          this.overlay = false
          this.loader = false
        });
    },
  },
  mounted() {
    // console.log("sel_crs LiveMCQ", this.sel_crs);
    this.getQuestionBank();
    this.learners = JSON.parse(localStorage.getItem('live-session-students'))
  },
};
</script>
<style scoped>
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
</style>